/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

import { Spinner } from '@vaisala/rockhopper-components';
import styles from './PageSpinner.module.css';

export const PageSpinner = () => (
  <div className={styles.pageSpinner}>
    <Spinner className={styles.spinner} />
  </div>
);
